import React               from 'react';
import ReactDOM            from 'react-dom';
import $                   from 'jquery';
import ShareWidget         from 'medscape/share-widget';
import VideoPlayer         from 'medscape/video';
import QNA                 from 'medscape/qna';
import GiftManager         from 'medscape/gift-manager';
import Carousel            from 'infosite/carousel';
import ConsultWidget       from 'medscape/consult-widget';
import IsiModule           from 'infosite/isi';
import IsiLink             from 'infosite/isi/link';
import Handlebars          from 'handlebars';
import Tracking            from 'medscape/tracking';
import Twitter             from 'medscape/twitter-widget';
import ZoomImages          from 'infosite/zoom-images';
import Formulary           from 'medscape/formulary';
import ResourcesContent    from 'infosite/resources';
import AdditionalResources from 'infosite/additional-resources';
import ConsultModule       from 'infosite/consult';
import UldBannerModule     from 'medscape/uld';

const Helpers = {
  setBrowserHistory(browserHistory) {
    this.browserHistory = browserHistory;
  },
  loadCarouselModules(el=false, callbacks) {
    if(!el) {
      return;
    }
    let $el = $(el);
    let infosite = window.infosite;
    // VideoPlayer.init(infosite.config["videos"], $el.find(VideoPlayer.selector));
    ZoomImages.init(infosite.config["zoomImages"], $el.find(ZoomImages.selector),callbacks.ZoomImages);
    // QNA.init(infosite.config["Questionnaires"], $el.find(QNA.selector));
    this.loadRouterLinks($el);
    Tracking.trackContainerLinks(el);
  },
  load(el = document) {
    let $el = $(el);
    let infosite = window.infosite;
    ShareWidget.init(infosite.config["share-widgets"], $el.find(ShareWidget.selector));
    VideoPlayer.init(infosite.config["videos"], $el.find(VideoPlayer.selector), this.browserHistory);
    QNA.init(infosite.config["Questionnaires"], $el.find(QNA.selector));
    GiftManager.init(infosite.config["giftManager"], $el.find(GiftManager.selector));
    ConsultWidget.init(infosite.config["consult-widget"], $el.find(ConsultWidget.selector));
    IsiModule.init(infosite.config["isi"], $el.find(IsiModule.selector));
    Twitter.init(infosite.config["twitterTimeLine"], $el.find(Twitter.selector));
    ZoomImages.init(infosite.config["zoomImages"], $el.find(ZoomImages.selector));
    Formulary.init(infosite.config["formulary"], $el.find(Formulary.selector));
    Carousel.init(infosite.config["carousel"], $el.find(Carousel.selector));
    ResourcesContent.init(infosite.config["resources"], $el.find(ResourcesContent.selector));
    AdditionalResources.init(infosite.config["additional-resources"], $el.find(AdditionalResources.selector));
    ConsultModule.init(infosite.config["consult-ad"]);
    UldBannerModule.init(infosite.config["uld"]);

    if (window.medscape.isMobile) {
      // MobileMenu.init(infosite.config["navigation"]);
    }
    this.loadIsiLink(el);
    this.loadRouterLinks($el);
    Tracking.trackContainerLinks(el);
  },
  loadIsiLink(el) {
    let $el = $(el);
    let infosite = window.infosite;
    IsiLink.init(infosite.config["isi"], $el.find(IsiLink.selector));
  },
  loadRouterLinks($el) {
    $el.find('[data-module="RouterLink"]').each((index, el) => {
      let $link = $(el);
      let path = $link.attr('href');
      $link.attr('href', window.medscape.config.appServer.path + path);
      $link.data('to', path);
    })
    $el.find('[data-module="RouterLink"]').off('click.RouterLink').on('click.RouterLink', (e) => {
      e.preventDefault();
      let $link = $(e.currentTarget);
      let path = $link.data('to');
      if (this.browserHistory != null) {
        this.browserHistory.push(path)
      }
    })
  },
  loadStickyHeader() {
    let infosite = window.infosite;
    // const transitionEndEvent = 'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend';
    let $window = $(window);
    let $infositeApp = $('#infosite-app');
    let $main = $($infositeApp.find('main')[0])
    let $header = $('header');
    let headerHeight = $header.outerHeight();
    let defaultTop = $main.css('margin-top');
    let triggerPoint = infosite.config.header.desktop.stickyTriggerPoint || '50%'; //infositeConfig.desktop.header["trigger-point"] || '100%' ;
    let scrollTimer;

    if (this.lockedScrolls.length>0) {
      return;
    }
    if (triggerPoint.endsWith("%")) {
      triggerPoint = headerHeight * parseFloat(triggerPoint) / 100;
    }

    $window.off('scroll.stickyHeader').on('scroll.stickyHeader', (e) => {
      if (this.lockedScrolls.length>0) {
        return;
      }
      if ($window.scrollTop() > triggerPoint) {
        if (!$header.hasClass("sticky")) {
          headerHeight = $header.outerHeight();
          defaultTop = parseInt($main.css('margin-top'));
          $main.css('margin-top', defaultTop + headerHeight);
          $header.addClass("sticky");
        }
      } else {
        $main.css('margin-top', defaultTop);
        $header.removeClass("sticky");
      }
    });
  },
  pauseVideos(el){
    VideoPlayer.pause(el);
  },
  unload(el) {
    if (el == null) {
      // console.warn("React container element is required");
      return;
    }
    $(el).find('[data-module]').each((index, container) => {
      ReactDOM.unmountComponentAtNode(container);
    })
  },
  updatePage(page = {}) {
    let pageTitle = page["meta-data"] && page["meta-data"].h1 ? page["meta-data"].h1 : undefined;;
    if(!pageTitle){
      pageTitle = page["meta-data"] && page["meta-data"].titleTag ? page["meta-data"].titleTag : undefined;
    }
    let $title = $('title');
    let $metaTitle = $('meta[property="og:title"]');
    if (!$title.data('title')) {
      $title.data('title', $title.html());
    }
    if (!$metaTitle.data('title')) {
        $metaTitle.data('title', $metaTitle.attr('content'));
    }
    pageTitle = pageTitle || $title.data('title');
    $('meta[property="og:url"]').attr("content", document.location.href);
    //$title.html(pageTitle);
    $metaTitle.attr("content", pageTitle);
    window.scrollTo(0, 0);
    Tracking.pageView();
  },
  lockedScrolls: [],
  lockScroll(key=null) {
    if(key==null) {
      return;
    }
    if (this.lockedScrolls.length > 0) {
      if (this.lockedScrolls.indexOf(key) < 0) {
        this.lockedScrolls.push(key);
      }
      return;
    }
    let $app = $('#infosite-app');
    $app.data('lockScroll', true);
    let $html = $('html');
    var scrollPosition = [
      document.documentElement.scrollLeft || document.body.scrollLeft,
      document.documentElement.scrollTop || document.body.scrollTop
    ];
    $html.data('scroll-position', scrollPosition);
    $html.data('previous-overflow', $html.css('overflow'));
    // lockScroll for mobile devices
    $('html, body').css({
      overflow: 'hidden',
      height: '100vh',
      width: '100%'
    });
    $('body').on('touchmove.lockScroll', function(e) {
      e.preventDefault();
    });
    const scrollAreas = [
      '.content-scroll-area',
      '.ReactModal__Overlay',
      '.bm-menu'
    ]
    scrollAreas.forEach((scrollClass)=>{
      $('body').on('touchmove.lockScroll', scrollClass, (e) => {
        e.stopPropagation();
        return true;
      });
    });
    //console.log("scrollPosition:", scrollPosition);
    window.scrollTo(scrollPosition[0], scrollPosition[1]);

    $app.data('style', $app.attr('style') ? $app.attr('style') : '');
    $('#infosite-app').css({
      left: -scrollPosition[0],
      top: -scrollPosition[1],
      position: 'relative'
    });
    this.lockedScrolls.push(key);
  },
  unlockScroll(key=null) {
    if (this.lockedScrolls.length == 0 || key==null) {
      return;
    }
    this.lockedScrolls = this.lockedScrolls.filter((lock) => {
      return lock != key;
    });
    if (this.lockedScrolls == null) {
      this.lockedScrolls = [];
    }
    if (this.lockedScrolls.length > 0) {
      return;
    }
    let $app = $('#infosite-app');
    $app.data('lockScroll.lockScroll', false);
    let $html = $('html');
    var currentOverflow = $html.data('previous-overflow');
    var scrollPosition = $html.data('scroll-position');
    // unlockScroll for mobile devices
    $('body').off('touchmove.lockScroll');
    $('html, body').css({
        overflow: currentOverflow,
        height: 'auto'
    });
    $app.attr('style', $app.data('style'));
    window.scrollTo(scrollPosition[0], scrollPosition[1]);
  }
};
$(document).on('lockScroll', (e, flag, key)=>{
  if(flag) {
    Helpers.lockScroll(key);
  } else {
    Helpers.unlockScroll(key);
  }
});

export default Helpers;



// WEBPACK FOOTER //
// ./src/app/helpers.js